module.exports = __webpack_public_path__ + "fonts/Lato-MediumItalic.96f82879.ttf";